export const SOFTLINE_API_TRANSPORTAUFTRAG = '/v1/transportauftrag/entities';
export const SOFTLINE_API_TRANSPORTAUFTRAG_DETAILS =
  '/v1/transportauftrag/entities/{{id}}/details';
export const SOFTLINE_API_TRANSPORTAUFTRAG_ZUSATZARTIKEL =
  '/v1/transportauftrag/zusatzartikel';

export const SOFTLINE_API_TRANSPORTAUFTRAG_UPDATE_KOPFTEXT =
  '/v1/transportauftrag/entities/{{id}}/kopflf/entities/{{idkopflf}}';
export const SOFTLINE_API_TRANSPORTAUFTRAG_STATION_SIGN =
  '/v1/transportauftrag/entities/{{id}}/kopflf/entities/{{idkopflf}}/sign';
export const SOFTLINE_API_TRANSPORTAUFTRAG_DELIVERY_NOTE_DOWNLOAD =
  '/v1/transportauftrag/entities/{{id}}/kopflf/entities/{{idkopflf}}/druck';
export const SOFTLINE_API_TRANSPORTAUFTRAG_DELIVERY_NOTE_ABSCHLUSSTYPEN =
  '/v1/transportauftrag/entities/{{id}}/kopflf/abschlusstypen';
export const SOFTLINE_API_TRANSPORTAUFTRAG_DELIVERY_NOTE_CREATE =
  '/v1/transportauftrag/entities/{{id}}/kopflf/create';
export const SOFTLINE_API_TRANSPORTAUFTRAG_DELIVERY_NOTE_SEND =
  '/v1/transportauftrag/entities/{{id}}/kopflf/entities/{{idkopflf}}/belegversand';
